module.exports = __webpack_public_path__ + "static/front-page-05-4ff8be3ac7891c2a40a66c2851898fc3.jpg";